import { render, staticRenderFns } from "./marcarOutras.vue?vue&type=template&id=66e0d69c&"
import script from "./marcarOutras.vue?vue&type=script&lang=js&"
export * from "./marcarOutras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports